import { render, staticRenderFns } from "./PosterCarousel.vue?vue&type=template&id=1daeb08c"
import script from "./PosterCarousel.vue?vue&type=script&lang=ts"
export * from "./PosterCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports